import { useQuery } from '@tanstack/react-query';
import { dashboardService } from '../services/dashboard.service';
import type { Dashboard } from '../services/dashboard.service';

export function useDashboard(dashboardId: string | null) {
  return useQuery<Dashboard>({
    queryKey: ['dashboard', dashboardId],
    queryFn: () => {
      if (!dashboardId) {
        throw new Error('Dashboard ID is required');
      }
      return dashboardService.findById(dashboardId);
    },
    enabled: !!dashboardId,
    staleTime: 5 * 60 * 1000, // 5 minutes
  });
}

